import type { HeatCellClass, HeatValue } from '../types';

/** Cell style for one measured hour. */
export const heatCellClass = (value: HeatValue): HeatCellClass =>
  value === 'd' ? 'hd' : value === 'f' ? 'hf' : (`h${value}` as HeatCellClass);
